@if (canAdd && !disabled && !added) {
	<button class="btn btn-secondary round hover-blue" [ngClass]="{ 'extra-padding': parts }" (click)="addToBag()">
		@if (!parts) {
		{{ "CUSTOMIZER.COMPONENTS.CONFIGURATION.ADDTOBAG" | translate }}
		}
		@else {
		@if (parts === 1) {
		{{ "CUSTOMISER.MENUS.PARTS.ADD_PART_TO_BAG" | translate }}
		}
		@else {
		{{ "CUSTOMISER.MENUS.PARTS.ADD_PARTS_TO_BAG" | translate }}
		}
		}
	</button>
	}
	
	@if (added) {
	<button class="btn btn-primary round extra-padding" disabled>
		{{ "CUSTOMIZER.COMPONENTS.CONFIGURATION.ADDEDTOBAG" | translate }}
	</button>
	}
	
	@if ((!canAdd || disabled) && !added) {
	<button class="btn btn-primary round disabled" (click)="cannotAddClick()">
		{{ "CUSTOMIZER.COMPONENTS.CONFIGURATION.ADDTOBAG" | translate }}
	</button>
	}